import { render, staticRenderFns } from "./RestPasswd.vue?vue&type=template&id=7a2eb8b2"
import script from "./RestPasswd.vue?vue&type=script&lang=js"
export * from "./RestPasswd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports